export default __webpack_public_path__ + "63bcef0f8bd0db060dfd195772d91be3.png";